import FeatureGate from "@/src/components/feature-gate";
import WikiDetailScreen from "@/src/screens/wiki/wiki-detail-screen/wiki-detail-screen";

export default function WikiArticleDetail() {
  return (
    <FeatureGate feature="wiki">
      <WikiDetailScreen />
    </FeatureGate>
  );
}
